<template>
<div class="page page_settle">
    <div class="adress">
        <div class="info" v-if="selectAddress&&selectAddress.address_id">
            <div class="user">{{ selectAddress.address_person }} {{ selectAddress.address_phone }}</div>
            <div class="dizhi" @click="clickAdress">{{ selectAddress.address }}</div>
        </div>
        <div class="info" v-else>
            <div class="user">请选择收货地址</div>
        </div>
        <div class="icon_right" @click="clickAdress"></div>
    </div>
    <!-- 订单 -->
    <div class="order_wrap">
        <div class="order" v-for="(item,index) in carts" :key="index">
            <div class="order_top">
                <img :src="item.tradesman_thumb? ( $publicData.withHttpStart(item.tradesman_thumb) ? item.tradesman_thumb : imageUrl+item.tradesman_thumb) :$publicData.defaultTouxiang" alt="" class="thumb">
                <span class="shop_name">{{ item.tradesman_name }}</span>
            </div>
            <div class="order_list">
                <div class="item clearfix" v-for="(goods,index) in item.goods" :key="index">
                    <div class="item_l f-l">
                        <img :src="goods.good_thumb ? imageUrl+goods.good_thumb : $publicData.intangibleDefault" alt="" class="tu">
                    </div>
                    <div class="item_r f-l">
                        <div class="item_r_t">
                            <div class="title slh_s">{{ goods.good_title }}</div>
                            <div class="sku slh_s">{{ goods.good_spec_name }}</div>
                            <div class="sku slh_s">数量：{{ goods.good_nums }}</div>
                        </div>
                        <div class="price"><span class="tag_cash">¥</span>{{ goods.good_price }}</div>
                    </div>
                </div>
            </div>
            <!-- 是否自提 -->
            <div class="order_pro" v-if="item.ztpoint&&item.ztpoint.length>0">
                <div class="pro_l">是否自提</div>
                <div class="pro_r">
                    <van-radio-group v-model="item.ziti">
                        <van-radio :name="1" @click="clickZT(item)">
                            是
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
                            </template>
                        </van-radio>
                        <van-radio :name="0" @click="clickZT(item)">
                            否
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-radio>
                    </van-radio-group>
                </div>
            </div>
            <!-- 自提点 -->
            <van-radio-group v-model="item.selectzt" v-if="item.ziti">
                <van-cell-group class="cell_group">
                    <van-cell :border="false" clickable v-for="point in item.ztpoint" :key="point.zt_id" @click="item.selectzt = point.zt_id" class="order_pro">
                        <template #title>
                            <span class="custom-title pro_l">{{point.address}}</span>
                        </template>
                        <template #right-icon>
                            <van-radio :name="point.zt_id" class="pro_r">
                                <template #icon="props">
                                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                </template>
                            </van-radio>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
            <!-- 邮费 -->
            <div class="order_pro youfei" v-if="item.ziti!=1">
                <div class="pro_l">邮费</div>
                <div class="pro_r">
                    <div class="normal" v-if="item.fare_type==0">包邮</div>
                    <div class="post" v-if="item.fare_type==1">满￥{{item.fare_money}}包邮</div>
                    <div class="post" v-if="item.fare_type==2">￥{{item.addressFare?item.addressFare:item.fare}}</div>
                </div>
            </div>
			<!-- 折扣 只有b2c商品有折扣,b2b无折扣,is_platprice 为0是b2c商品-->
			<div class="order_pro youfei" v-if="discount && discount != 0 && item.is_platprice == 0">
				<div class="pro_l">折扣</div>
                <div class="pro_r">
                    <div class="normal">{{ dazhe }}</div>
                </div>
			</div>
        </div>
    </div>
	<!-- 折扣 -->
	<!-- <div class="quan_wrap discount" v-if="discount && discount != 0">
        <div class="quan">
            <div class="quan_l">折扣</div>
            <div class="quan_r">{{ dazhe }}</div>
        </div>
    </div> -->
    <!-- 优惠券 -->
    <div class="quan_wrap">
        <div class="quan">
            <div class="quan_l">优惠券</div>
            <div class="quan_r">无可用优惠</div>
        </div>
    </div>
    <!-- 立即购买 -->
    <div class="bottom tijiao">
        <div class="tijiao_l">共{{ allCount }}件，合计：<span class="price"><span class="tag_cash">¥</span>{{ allPrice }}</span></div>
        <div class="tijiao_r" @click="toPay">立即支付</div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN,
    SETTLE,
    SELECTADDRESS
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            activeIcon: process.env.BASE_URL + './statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + './statics/images/inactive.png',
            carts: {},
            allCount: 0,
            allPrice: 0,
            selectAddress: null,
            token: null,
            buy: null,
			imageUrl: this.$publicData.uploadImage,
			discount: this.$route.query.discount, // 折扣
			dazhe: null, // 打几折
        };
	},
    components: {
        // PageSearch
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '结算',
                    naviBlackStyle: false,
                    levitate: false
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    // 'notCallLogin': 1
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    // this.token = this.$store.getters.token
                    // console.log(this.$store.getters.shop_settle)
                    var settle = JSON.parse(this.$store.getters.shop_settle)
                    this.initData(settle)
                    
                }
            })
            // var params1 = {
            //     'data': {
            //         'key': 'settle'
            //     }
            // }
            // this.$bridge.callhandler('sdjy://public/getInfo', params1, (data1) => {
            //     console.log('sdjy://public/getInfo')
            //     console.log(params1)
            //     console.log(data1)
            //     if (data1.code == 200) {
            //         // alert(JSON.stringify(data1.result.data))
            //         var settle = JSON.parse(data1.result.data)
            //         this.initData(settle)
            //     }
            //     this.$bridge.callhandler('sdjy://public/removeInfo', params1, (data1) => {

            //     })
            // })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                // var params2 = {
                //     'data': {
                //         'key': 'selectAddress'
                //     }
                // }
                // this.$bridge.callhandler('sdjy://public/getInfo', params2, (data2) => {
                //     console.log('sdjy://public/getInfo')
                //     console.log(params2)
                //     console.log(data2)
                //     if (data2.code == 200) {
                //         var selectAddress = JSON.parse(data2.result.data)
                //         if (selectAddress) {
                //             this.selectAddress = selectAddress
                //             this.getFare()
                //         }
                //         this.$bridge.callhandler('sdjy://public/removeInfo', params2, (data1) => {

                //         })
                //     }
                // })
                // responseCallback(data)
            })
            
        } else {
            this.token = this.$store.getters.token
            // console.log(this.$store.getters.shop_settle)
            var settle = JSON.parse(this.$store.getters.shop_settle)
            this.initData(settle)
		}
		// console.log('vue实例',this)
    },
    mounted() {
		// 折扣
		if(this.$route.query.discount){
			var discount = (this.$route.query.discount).toString()
			var zhe = ''
			if(discount.length == 1){
				zhe = discount / 10 + '折'
			}else if(discount.length > 1){
				if(discount[discount.length-1] == 0){
					zhe = discount / 10 +'折'
				}else{
					zhe = discount + '折'
				}
			}
			this.dazhe = zhe
		}
    },
    methods: {
        initData(settle) {
            console.log('settle222:',settle)
            if (settle.buy == 1) {
                this.buy = 1
                var cart = {}
                cart.tradesman_id = settle.tradesman_id
                cart.tradesman_uuid = settle.tradesman_uuid
                cart.tradesman_name = settle.tradesman_name
                cart.tradesman_thumb = settle.tradesman_thumb
                cart.goods = [settle.goods]
                cart.fare_type = settle.fare_type
                cart.fare = settle.fare
				cart.addressFare = cart.fare
				cart.is_platprice = settle.is_platprice
                cart.fare_money = settle.fare_money
                cart.ziti = 0
                cart.ztpoint = settle.ztpoint
                this.carts = [cart]
                
            } else {
                // settle.carts.ziti = 0
                for (let i = 0; i < settle.carts.length; i++) {
                    var item = settle.carts[i];
                    item.ziti = 0
                    item.addressFare = item.fare
                    settle.carts[i] = item
                }
                this.carts = settle.carts
            }
			// 当有点选地址时
			if(this.$store.getters.select_address){
				let selectAddress = JSON.parse(this.$store.getters.select_address);
				// 验证是否为当前用户的
				this.testAddress(selectAddress);
			}else{
				if(settle.address && settle.address.length != 0){
					this.selectAddress = settle.address
					this.getFare()
				}
			}
            this.setPrice()
        },
		// 验证所选地址是否为当前用户的
		testAddress(current){
			let list = [];
			let is_have = false;
			this.$api.address.addressList({
				token: this.token,
				page: 1,
				size: 100
			}).then(res=>{
				list = res.result;
				for(let j in list){
					if(current.address_id == list[j].address_id){
						is_have = true;
						break;
					}
				};
				if(is_have){
					this.selectAddress = current;
					this.getFare();
				}else{
					this.$store.commit('REMOVEADDRESS');
				}
			})
		},
        //获取邮费
        getFare() {
            if (this.selectAddress && this.selectAddress.address_id) {
                var list = this.carts
                var trads = []
                for (let i = 0; i < list.length; i++) {
                    var item = list[i];
                    trads.push(item.tradesman_id)
                }
                if (trads.length <= 0 ) {
                    return
                }
                var params = {
                    token: this.token,
                    address_id: this.selectAddress.address_id,
                    tradesman_id: trads
                };
                this.$api.shop.fare(params).then((res) => {
                    if (res.code == 200) {
                        var list = this.carts
                        for (let i = 0; i < list.length; i++) {
                            var item = list[i];
                            var addressFare = res.result[item.tradesman_id]
                            if (addressFare != 0) {
                                item.addressFare = addressFare
                            } else {
                                item.addressFare = item.fare
                            }
                            list[i] = item
                        }
                        this.carts = list
                        this.setPrice()
                    } else {
                        this.$toast(res.message);
                    }
                });
            }
        },
        //设置价格
        setPrice() {
            var count = 0
            var price = 0
			var list = this.carts
			// console.log('this.carts----',this.carts)
            for (let i = 0; i < list.length; i++) {
                var item = list[i];
                item.zt = 0
                var tradesPrice = 0
                for (let j = 0; j < item.goods.length; j++) {
                    const goods = item.goods[j];
                    count += goods.good_nums
                    tradesPrice += (goods.good_nums * goods.good_price) // 商品总价 单价*数量
				}
				// 计算折扣 -- b2c商品计算折扣, b2b商品不计入折扣
				// console.log('item-----',item)
				if(item.is_platprice == 0){
					if(this.discount && this.discount != 0){
						tradesPrice = (tradesPrice*(this.discount/100)).toFixed(2)
					}
				}
				console.log('tradesPrice-------',tradesPrice)
				// 计算运费
                // console.log(item.ziti)
                if (item.ziti == 0) {
					console.log('邮寄')
                    if (item.fare_type == 0) {
                    } else if (item.fare_type == 1) {
						// console.log('1111111111')
                        if (tradesPrice < parseFloat(item.fare_money) ) {
                            if (item.addressFare != null && item.addressFare != undefined && item.addressFare != '') {
								tradesPrice = parseFloat(tradesPrice) + parseFloat(item.addressFare)
                            } else {
								tradesPrice = parseFloat(tradesPrice) + parseFloat(item.fare)
                            }
                        }
                    } else if (item.fare_type == 2) {
						// console.log('222222222')
                        if (item.addressFare != null && item.addressFare != undefined && item.addressFare != '') {
								tradesPrice = parseFloat(tradesPrice) + parseFloat(item.addressFare)
								// console.log('parseFloat(item.addressFare)-----',parseFloat(item.addressFare),tradesPrice)
                        } else {
							tradesPrice = parseFloat(tradesPrice) +  parseFloat(item.fare)
							
                        }
                    }
				}else{
					console.log('自提')
				}
                // console.log('tradesPrice+++++++',tradesPrice)
                price = parseFloat(price) + parseFloat(tradesPrice)
				list[i] = item
				console.log('price---------',price)
            }
            this.carts = list
			this.allCount = count
			this.allPrice = parseFloat(price).toFixed(2)
        },
        //创建订单
        toPay() {
			// 如果没有地址 提示去添加地址
			if( this.selectAddress.length == 0){
				this.$toast('请先选择地址')
				return;
			}
			// console.log('this.selectAddress',this.selectAddress)
            if (this.buy == 1) {
                this.buyGoodsDirect()
            } else {
                this.buyGoods()
            }
        },
        //直接购买
        buyGoodsDirect() { //goodsBuy
            var zts = {}
            var list = this.carts
            var cartId = ''
            var good = {}
            for (let i = 0; i < list.length; i++) {
                var newItem = list[i];
                if (newItem.ziti != 0) {
                    if (newItem.selectzt == null || newItem.selectzt == undefined || newItem.selectzt == '') {
                        this.$toast('请选择自提点')
                        return
                    }
                    zts[newItem.tradesman_id] = '1-' + newItem.selectzt
                } else {
                    zts[newItem.tradesman_id] = "0"
                }
                for (let j = 0; j < newItem.goods.length; j++) {
                    const goods = newItem.goods[j];
                    good = goods
                }
            }
            var params = {
                token: this.token,
                cartids: cartId,
                address_id: this.selectAddress.address_id,
                zts: zts,
                good: JSON.stringify(good)
            }
            console.log(params)
            this.$api.shop.goodsBuy(params).then(res=>{
                if(res.code == 200) {
                    window.localStorage.setItem('createOrder',res.result.pay_order_num)
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/shop/pay?orderId=' + res.result.pay_order_num + '&price=' + this.allPrice + '&isPlatprice=' + res.result.is_platprice + '&park_point=' + res.result.park_point + '&duihuan_money=' + res.result.duihuan_money +'&park_uuid=' + res.result.park_uuid
                            }
                        }
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {
						})
                        
                    } else {
                        console.log(res.result)
                        this.$router.push({
                            path: '/shop/pay',
                            query: {
                                orderId: res.result.pay_order_num,
                                price: this.allPrice,
                                isPlatprice: res.result.is_platprice,
                                park_point: res.result.park_point, // 所在园区积分
								duihuan_money: res.result.duihuan_money, // 积分兑换比例
								park_uuid: res.result.park_uuid,
								thirdJifenBili: res.result.plat_exchange_points_bili // 第三方积分兑换比例
                            }
                        })
                    }
                    // this.dataList = res.result
                } else {
                    this.$toast(res.message)
                }
            })
        },
        //购物车购买
        buyGoods() {
            var zts = {}
            var list = this.carts
            var cartId = ''
            var needAddress = false
            for (let i = 0; i < list.length; i++) {
                var newItem = list[i];
                console.log(newItem.ziti)
                if (newItem.ziti != 0 ) {
                    if (newItem.selectzt == null || newItem.selectzt == undefined || newItem.selectzt == '') {
                        this.$toast('请选择自提点')
                        return
                    }
                    zts[newItem.tradesman_id] = '1-' + newItem.selectzt
                } else {
                    zts[newItem.tradesman_id] = "0"
                    needAddress = true
                }
                for (let j = 0; j < newItem.goods.length; j++) {
                    const goods = newItem.goods[j];
                    if (cartId == '') {
                        cartId += goods.cart_id
                    } else {
                        cartId += ','
                        cartId += goods.cart_id
                    }
                }
            }
            if (needAddress) {
                if (this.selectAddress == null || this.selectAddress == undefined ||this.selectAddress == {} || this.selectAddress.address_id == null || this.selectAddress.address_id == undefined || this.selectAddress.address_id == '') {
                    this.$toast('请选择收货地址')
                    return
                }
            }
            var params = {
                token: this.token,
                cartids: cartId,
                address_id: this.selectAddress.address_id,
                zts: zts
            }
            console.log(params)
            this.$parent.showLoading()
            this.$api.shop.createOrder(params).then(res => {
                this.$parent.hiddenLoading()
                if (res.code == 200) {
                    window.localStorage.setItem('createOrder',res.result.pay_order_num)
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/shop/pay?orderId=' + res.result.pay_order_num + '&price=' + this.allPrice + '&isPlatprice=' + res.result.is_platprice + '&park_point=' + res.result.park_point + '&duihuan_money=' + res.result.duihuan_money +'&park_uuid='+ res.result.park_uuid
                            }
                        }
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    } else {
                        console.log(res.result)
                        this.$router.push({
                            path: '/shop/pay',
                            query: {
                                orderId: res.result.pay_order_num,
                                price: this.allPrice,
								isPlatprice: res.result.is_platprice,
								park_point: res.result.park_point, //所在园区积分
								duihuan_money: res.result.duihuan_money, // 积分兑换比例
								park_uuid: res.result.park_uuid,
								thirdJifenBili: res.result.plat_exchange_points_bili // 第三方积分兑换比例
                            }
                        })
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },
        //自提
        clickZT(selectItem) {
            // console.log(111)
            var list = this.carts
            for (let i = 0; i < list.length; i++) {
                var item = list[i];
                if (item.tradesman_id == selectItem.tradesman_id) {
					console.log('ziti ------',selectItem)
                    list[i] = selectItem
                    break
                }                
            }
            this.carts = list
			console.log(this.carts)
			this.setPrice()
        },
        // 收货地址
        clickAdress() {
            // if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //     var params = {
            //         'data': {
            //             'url': this.$publicData.clientUrl + '/user/adress?canSelect=1&addressId=' + this.selectAddress.address_id
            //         }
            //     }
            //     this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

            //     })
            // } else {
                this.$router.push({
                    path: '/user/adress',
                    query: {
                        canSelect: 1,
                        addressId: this.selectAddress?this.selectAddress.address_id:''
                    }
                })
            // }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	/deep/.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
		border: 0 none;
	}
</style>
